import TrainerService from "../services/TrainerService";
import router from "@/router";

const uuidv4 = require("uuid/v4");

const getDefaultState = () => ({
  count: 0,
  user: {
    uuid: "",
    user_name: "",
    email: "",
    admin: false,
    password: "",
    confirm: "",
  },
  trainer: {
    uuid: "",
    active: true,
    first_name: "",
    middle_name: "",
    last_name: "",
    designation: "",
    sex: "",
    dob: null,
    mobile_1: "",
    mobile_2: "",
    email: "",
    country: "",
    region: "",
    district: "",
    village: "",
    address: "",
    course_name: "",
    date_comp: "",
    institution: "",
  },
  observation: {
    id: null,
    obs_date: null,
    school_id: "",
    trainer_id: "",
    teacher_id: "",
    school_uuid: "",
    trainer_uuid: "",
    teacher_uuid: "",
    implemented: false,
    recommendation: "",
    engaged_principle: false,
    greet: false,
    work_displayed: false,
    play_shop: false,
    nature_box: false,
    dress_up_box: false,
    music: false,
    arts: false,
    reading_corner: false,
    matching_games: false,
    puzzles: false,
    book_making: false,
    conservation: false,
    gardening: false,
    lat: null,
    lng: null,
    coord: false,
  },
  observations: [],
  covidObservation: {
    id: null,
    obs_date: null,
    school_uuid: "",
    trainer_uuid: "",
    teacher_uuid: "",
    supplied_soap: false,
    hand_washing: false,
    masks_teacher: false,
    masks_student: false,
    social_distancing: false,
    individuals_infected: false,
    parent_covid_workshops_delivered: false,
  },
  covidObservations: [],
  trainers: [],
  trainersExport: [],
  trainerGroups: [],
  trainerSchools: [],
  trainerPrimarySchools: [],
  schoolTeachers: [],
  trainerSchoolNames: [],
  trainerTeachers: [],
  trainerSchoolsTeachers: [],
  trainerSchoolsTeachersNames: [],
  teachersArray: [],
  trainerModules: [],
  teachersWorkshops: [],
});

const trainers = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    userName(state, val) {
      state.user.user_name = val;
    },
    userEmail(state, val) {
      state.user.email = val;
    },
    password(state, val) {
      state.user.password = val;
    },
    confirm(state, val) {
      state.user.confirm = val;
    },
    count(state, val) {
      state.count = val;
    },
    active(state, val) {
      state.trainer.active = val;
    },
    first_name(state, val) {
      state.trainer.first_name = val;
    },
    middle_name(state, val) {
      state.trainer.middle_name = val;
    },
    last_name(state, val) {
      state.trainer.last_name = val;
    },
    dob(state, val) {
      state.trainer.dob = val;
    },
    sex(state, val) {
      state.trainer.sex = val;
    },
    designation(state, val) {
      state.trainer.designation = val;
    },
    mobile_1(state, val) {
      state.trainer.mobile_1 = val;
    },
    mobile_2(state, val) {
      state.trainer.mobile_2 = val;
    },
    email(state, val) {
      state.trainer.email = val;
    },
    country(state, val) {
      state.trainer.country = val;
    },
    region(state, val) {
      state.trainer.region = val;
    },
    district(state, val) {
      state.trainer.district = val;
    },
    village(state, val) {
      state.trainer.village = val;
    },
    address(state, val) {
      state.trainer.address = val;
    },
    course_name(state, val) {
      state.trainer.course_name = val;
    },
    date_comp(state, val) {
      state.trainer.date_comp = val;
    },
    institution(state, val) {
      state.trainer.institution = val;
    },
    observationDate(state, val) {
      state.observation.obs_date = val;
    },
    observationTrainer(state, val) {
      state.observation.date = val;
    },
    observationSchool(state, val) {
      state.observation.school_id = val;
    },
    observationTeacher(state, val) {
      state.observation.teacher_id = val;
    },
    observationRecommendation(state, val) {
      state.observation.recommendation = val;
    },
    observationImplemented(state, val) {
      state.observation.implemented = val;
    },
    observations(state, val) {
      state.observations = val;
    },
    covidObservationDate(state, val) {
      state.covidObservation.obs_date = val;
    },
    observationTrainer(state, val) {
      state.covidObservation.trainer_uuid = val;
    },
    observationSchool(state, val) {
      state.covidObservation.school_uuid = val;
    },
    observationTeacher(state, val) {
      state.covidObservation.teacher_uuid = val;
    },
    covidObservationSuppliedSoap(state, val) {
      state.covidObservation.supplied_soap = val;
    },
    covidObservationHandWashing(state, val) {
      state.covidObservation.hand_washing = val;
    },
    covidObservationMasksTeacher(state, val) {
      state.covidObservation.masks_student = val;
    },
    covidObservationMasksTeacher(state, val) {
      state.covidObservation.masks_teacher = val;
    },
    covidObservationSocialDistancing(state, val) {
      state.covidObservation.social_distancing = val;
    },
    covidObservationIndividualsInfected(state, val) {
      state.covidObservation.individuals_infected = val;
    },
    covidObservationParentCovidWorkshopsDelivered(state, val) {
      state.covidObservation.parent_covid_workshops_delivered = val;
    },
    covidObservations(state, val) {
      state.covidObservations = val;
    },
    trainerGroups(state, val) {
      state.trainerGroups = val;
    },
    trainerSchools(state, val) {
      state.trainerSchools = val;
    },
    trainerPrimarySchools(state, val) {
      state.trainerPrimarySchools = val;
    },
    schoolTeachers(state, val) {
      state.schoolTeachers = val;
    },
    trainerSchoolNames(state, val) {
      state.trainerSchoolNames = val;
    },
    trainerTeachers(state, val) {
      state.trainerTeachers = val;
    },
    trainerSchoolsTeachers(state, val) {
      state.trainerSchoolsTeachers = val;
    },
    trainerSchoolsTeachersNames(state, val) {
      state.trainerSchoolsTeachersNames = val;
    },
    teachersArray(state, val) {
      state.teachersArray = val;
    },
    trainerModules(state, val) {
      state.trainerModules = val;
    },
    teachersWorkshops(state, val) {
      state.teachersWorkshops = val;
    },
    resetTrainers(state) {
      Object.assign(state, getDefaultState());
    },
    resetList(state) {
      state.perPage = 10;
      state.currentPage = 1;
    },
  },
  actions: {
    async RESET_TRAINERS_STATE(context) {
      await context.commit("resetTrainers");
    },
    async GET_TRAINER_COUNT(context) {
      const res = await TrainerService.fetchTrainerCount();
      const { count } = res.data.results;
      context.commit("count", parseInt(count));
    },
    async CREATE_TRAINER({ state }) {
      const trainerData = { ...state.trainer };
      const userData = { ...state.user };
      const key = "dob";
      const key2 = "date_comp";
      trainerData.birthdate = state.trainer[key];
      trainerData.date_completed = state.trainer[key2];
      delete trainerData[key];
      delete trainerData[key2];
      delete userData.confirm;
      if (trainerData.birthdate === "") {
        trainerData.birthdate = null;
      }
      if (trainerData.date_completed === "") {
        trainerData.date_completed = null;
      }
      userData.uuid = uuidv4();
      trainerData.uuid = uuidv4();
      await TrainerService.addTrainer(userData, trainerData);
    },
    async GET_TRAINERS(context) {
      let data;
      if (context.rootState.auth.user.admin) {
        const res = await TrainerService.fetchTrainers();
        data = await res.data.trainers;
      }else if (context.rootState.auth.user.src) {
        console.log("is SRC BRUV"+context.rootState.auth.user.uuid)
        const res = await TrainerService.fetchClusterTrainers(context.rootState.auth.user.uuid);
        data = await res.data.trainers;
      }else if (context.rootState.auth.coordinatorBool) {
        const res = await TrainerService.fetchCoordinatorTrainers(
          context.rootState.auth.coordinator.uuid
        );
        data = await res.data.trainers;
      } else {
        console.log("isNT SRC BRUV")
        data = null;
      }
      context.rootState.trainers.trainers = data;
    },
    async GET_ALL_TRAINERS(context) {
      const res = await TrainerService.fetchTrainers();
      let data = await res.data.trainers;
      context.rootState.trainers.trainers = data;
    },
    async GET_TRAINERS_EXPORT(context) {
      const res = await TrainerService.fetchTrainersExport();
      const data = await res.data.trainers;
      context.rootState.trainers.trainersExport = data;
    },
    async GET_TRAINER(context) {
      const trainer = await TrainerService.getTrainer({
        uuid: router.currentRoute.params.id,
      });
      const data = await trainer.data.trainer[0];
      context.rootState.trainers.trainer = data;
    },
    async UPDATE_TRAINER({ state }) {
      const key = await "dob";
      const key2 = await "date_comp";
      state.trainer.birthdate = await state.trainer[key];
      state.trainer.date_completed = await state.trainer[key2];
      await delete state.trainer[key];
      await delete state.trainer[key2];
      await TrainerService.updateTrainer(state.trainer);
    },
    async GET_TRAINER_GROUPS(context) {
      const groups = await TrainerService.fetchTrainerGroups({
        id: router.currentRoute.params.id,
      });
      const data = groups.data.groups;
      context.commit("trainerGroups", data);
    },
    async GET_SCHOOL_NAMES_BY_TRAINER(context) {
      const schools = await TrainerService.fetchSchoolNamesByTrainer({
        id: router.currentRoute.params.id,
      });
      const data = schools.data.schools;
      context.commit("trainerSchoolNames", data);
    },
    async GET_TRAINER_TEACHERS(context) {
      const teachers = await TrainerService.fetchTrainerTeachers({
        id: router.currentRoute.params.id,
      });
      const data = teachers.data.teachers;
      context.commit("trainerTeachers", data);
    },
    async GET_TRAINER_SCHOOLS_TEACHERS(context) {
      const teachers = await TrainerService.fetchTrainerSchoolsTeachers({
        id: router.currentRoute.params.id,
      });
      const data = teachers.data.teachers;
      context.commit("trainerSchoolsTeachers", data);
    },
    async GET_TEACHER_NAMES_BY_TRAINER_SCHOOL(context, id) {
      const teachers = await TrainerService.fetchTeacherNamesByTrainerSchool(
        id
      );
      const data = teachers.data.teachers;
      context.commit("schoolTeachers", data);
    },
    async GET_TRAINER_OBSERVATIONS({context},type) {
      const res = await TrainerService.fetchTrainerObservationsByType(type);

      const data = await res.data.observations;
      context.commit("observations", data);
    },
    async GET_TRAINER_COVID_OBSERVATIONS(context) {
      const res = await TrainerService.fetchTrainerCovidObservations({
        id: router.currentRoute.params.id,
      });

      const data = await res.data.observations;
      context.commit("covidObservations", data);
    },
    async GET_TRAINER_MODULES(context) {
      const modules = await TrainerService.fetchTrainerModules({
        id: router.currentRoute.params.id,
      });
      const data = modules.data.results;
      context.commit("trainerModules", data);
    },
    async GET_TRAINER_SCHOOLS(context) {
      const schools = await TrainerService.fetchTrainerSchools({
        id: router.currentRoute.params.id,
      });
      const data = schools.data.schools;
      context.commit("trainerSchools", data);
    },
    async GET_TRAINER_PRIMARY_SCHOOLS(context) {
      const schools = await TrainerService.fetchTrainerPrimarySchools({
        id: router.currentRoute.params.id,
      });
      const data = schools.data.schools;
      context.commit("trainerPrimarySchools", data);
    },
    async GET_TEACHER_WORKSHOPS(context) {
      const workshops = await TrainerService.fetchTrainerTeacherWorkshops({
        id: router.currentRoute.params.id,
      });
      const data = workshops.data.results;
      context.commit("teachersWorkshops", data);
    },
  },
  getters: {
    getTrainers: (state) => state.trainers,
  },
};

export default trainers;
